module.exports = __webpack_public_path__ + "img/searchnapplyjobs.c769a44b.svg";